import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["button", "cancel"]

  disconnect() {
    if (this.modalContainer) {
      delete this.modalContainer.dataset.preventClose;
    } else {
      const modal = this.element.closest('[data-controller="modal"]');
      if (modal) {
        delete modal.dataset.preventClose;
      }
    }
  }

  disable(event) {
    if (!this.hasButtonTarget) return;

    this.submitPending = true;
    this.disableTimeout = setTimeout(() => {
      if (!this.submitPending) return;

      const button = this.buttonTarget;
      const text = button.dataset.disableText;

      const clone = button.cloneNode(true);
      clone.disabled = true;
      clone.removeAttribute("data-disable-submit-target");

      if (text) {
        if (clone.tagName === 'INPUT') {
          clone.value = text;
        } else {
          clone.textContent = text;
        }
      }

      button.style.display = 'none';
      button.insertAdjacentElement('afterend', clone);
      this.clone = clone;
      this.disabledButton = button;
      this.disabledClone = clone;

      // Prevent modal closing
      const modal = this.element.closest('[data-controller="modal"]');
      if (modal) {
        modal.dataset.preventClose = "true";
        this.modalContainer = modal;
      }

      // Disable interactions with the form
      this.element.classList.add("pointer-events-none", "opacity-75");

      if (this.hasCancelTarget) {
        this.cancelStates = new Map();
        this.cancelTargets.forEach((cancelBtn) => {
          this.cancelStates.set(cancelBtn, {
            disabled: cancelBtn.disabled,
            className: cancelBtn.className
          });
          cancelBtn.classList.add("opacity-50", "pointer-events-none");
          cancelBtn.disabled = true;
        });
      }
    }, 0);
  }

  // A submission whose response doesn't re-render this form/button (e.g. a
  // flash-only error response) would otherwise leave the button stuck
  // disabled forever, since `disable()` above never runs again on a fresh
  // element. Revert it by hand when the submission itself failed.
  submitEnd(event) {
    if (event.detail?.success !== false) return;
    this.reset();
  }

  reset() {
    if (this.clone) {
      this.clone.remove();
      this.clone = null;
    }
    if (this.hasButtonTarget) {
      this.buttonTarget.style.display = '';
    }

    if (this.modalContainer) {
      delete this.modalContainer.dataset.preventClose;
      this.modalContainer = null;
    }

    this.element.classList.remove("pointer-events-none", "opacity-75");

    if (this.hasCancelTarget) {
      this.cancelTargets.forEach((cancelBtn) => {
        cancelBtn.classList.remove("opacity-50", "pointer-events-none");
        cancelBtn.disabled = false;
      });
    }
  }

  enable() {
    this.submitPending = false;
    clearTimeout(this.disableTimeout);

    // A failed validation keeps the same modal mounted, so disconnect() may
    // not run. Release the close guard here as well.
    const modal = this.modalContainer || this.element.closest('[data-controller="modal"]');
    if (modal) delete modal.dataset.preventClose;
    this.modalContainer = null;

    this.disabledClone?.remove();
    if (this.disabledButton) this.disabledButton.style.display = '';

    this.element.classList.remove("pointer-events-none", "opacity-75");
    this.cancelStates?.forEach((state, cancelBtn) => {
      cancelBtn.disabled = state.disabled;
      cancelBtn.className = state.className;
    });

    this.disabledButton = null;
    this.disabledClone = null;
    this.cancelStates = null;
  }
}
